// extracted by mini-css-extract-plugin
export var articles = "index-module--articles--AB3oK";
export var navItem = "index-module--nav-item--l-FzI";